class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.listItem = this.closest(".main-link");
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.init();
  }

  init() {
    this.listItem.addEventListener("mouseover", this.open.bind(this));
    this.listItem.addEventListener("mouseleave", this.close.bind(this));
    this.mainDetailsToggle.addEventListener("click", this.redirect.bind(this));
  }

  redirect() {
    const detailUrl = this.mainDetailsToggle.dataset.href;
    if(detailUrl) window.location.href = detailUrl;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', "");
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
